import { creatorbase, PaypalTransactionStatus, tipalti } from '@round/api';
import { Badge } from '@round/whitelabel-ui';
import cn from 'classnames';
import styles from './PaymentStatusBadge.module.css';
import { getPaymentStatusLabel, getPaymentStatusStyleString } from './helpers';

type Props = {
    status:
        | creatorbase.PostPaymentRequestStatus
        | PaypalTransactionStatus
        | creatorbase.PostPaymentStatus
        | tipalti.TipaltiTransactionStatus;
    className?: string;
};

const PaymentStatusBadge = ({ status, className }: Props) => {
    return (
        <Badge className={cn(styles.badge, styles[getPaymentStatusStyleString(status)], className)}>
            {getPaymentStatusLabel(status)}
        </Badge>
    );
};

export default PaymentStatusBadge;
